
import CategoryCard from './CategoryCard'

export default function CategoriesList({ website }) {
  const deployCategories=()=>{
    return website?.settings?.categories?.map((item, inx)=>{
      return <CategoryCard key={`categoryCard_${inx}`} website={website} item={item}/>
    })
  }
  return website?.settings?.categories?.length > 0 ? (
    <div className='categoriesList'>
      {deployCategories()}
    </div>
  ) : <h3 dir='rtl' style={{margin:"0 auto 50px", width:"100%"}}>הרשימה ריקה</h3>
}
